import React, { useState } from 'react';
import { mockKhatians } from '../data/mockData';
import { Search, Filter, Eye, Download, FileText, Map, RotateCcw } from 'lucide-react';
import { KhatianDocument } from '../components/KhatianDocument';
export const KhatianViewer: React.FC = () => {
  const [filters, setFilters] = useState({
    division: '',
    district: '',
    upazila: '',
    mouja: '',
    khatianNo: '',
    publishDate: ''
  });
  const [selectedKhatian, setSelectedKhatian] = useState<any>(null);
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };
  const resetFilters = () => {
    setFilters({
      division: '',
      district: '',
      upazila: '',
      mouja: '',
      khatianNo: '',
      publishDate: ''
    });
  };
  const filteredKhatians = mockKhatians.filter(k => {
    if (k.status !== 'published') return false;
    if (filters.division && k.division !== filters.division) return false;
    if (filters.district && k.district !== filters.district) return false;
    if (filters.upazila && k.upazila !== filters.upazila) return false;
    if (filters.mouja && !k.mouja.toLowerCase().includes(filters.mouja.toLowerCase())) return false;
    if (filters.khatianNo && !k.khatianNo.includes(filters.khatianNo)) return false;
    if (filters.publishDate && k.publishedDate !== filters.publishDate) return false;
    return true;
  });
  return <div className="max-w-7xl mx-auto flex flex-col h-[calc(100vh-8rem)]" data-id="element-990">
      <div className="mb-6" data-id="element-991">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-992">
          প্রকাশিত খতিয়ান ভাণ্ডার
        </h1>
        <p className="text-slate-500" data-id="element-993">
          ডিএলএমএস থেকে চূড়ান্ত ভূমি রেকর্ড খুঁজুন এবং দেখুন
        </p>
      </div>

      <div className="flex gap-6 flex-1 overflow-hidden" data-id="element-994">
        {/* Main List */}
        <div className={`flex flex-col bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden transition-all duration-300 ${selectedKhatian ? 'w-1/3 hidden lg:flex' : 'w-full'}`} data-id="element-995">
          <div className="p-4 border-b border-slate-200 bg-slate-50" data-id="element-996">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-3" data-id="element-997">
              <select name="division" value={filters.division} onChange={handleFilterChange} className="input-field py-1.5 text-sm" data-id="element-998">
                <option value="" data-id="element-999">সকল বিভাগ</option>
                <option value="Dhaka" data-id="element-1000">ঢাকা</option>
                <option value="Chittagong" data-id="element-1001">চট্টগ্রাম</option>
                <option value="Rajshahi" data-id="element-1002">রাজশাহী</option>
                <option value="Khulna" data-id="element-1003">খুলনা</option>
                <option value="Barisal" data-id="element-1004">বরিশাল</option>
                <option value="Sylhet" data-id="element-1005">সিলেট</option>
                <option value="Rangpur" data-id="element-1006">রংপুর</option>
                <option value="Mymensingh" data-id="element-1007">ময়মনসিংহ</option>
              </select>
              <select name="district" value={filters.district} onChange={handleFilterChange} className="input-field py-1.5 text-sm" data-id="element-1008">
                <option value="" data-id="element-1009">সকল জেলা</option>
                <option value="Dhaka" data-id="element-1010">ঢাকা</option>
                <option value="Chittagong" data-id="element-1011">চট্টগ্রাম</option>
                <option value="Narayanganj" data-id="element-1012">নারায়ণগঞ্জ</option>
              </select>
              <select name="upazila" value={filters.upazila} onChange={handleFilterChange} className="input-field py-1.5 text-sm" data-id="element-1013">
                <option value="" data-id="element-1014">সকল উপজেলা</option>
                <option value="Savar" data-id="element-1015">সাভার</option>
                <option value="Hathazari" data-id="element-1016">হাটহাজারী</option>
                <option value="Rupganj" data-id="element-1017">রূপগঞ্জ</option>
              </select>
              <input type="text" name="mouja" value={filters.mouja} onChange={handleFilterChange} placeholder="মৌজা" className="input-field py-1.5 text-sm" data-id="element-1018" />
              <input type="text" name="khatianNo" value={filters.khatianNo} onChange={handleFilterChange} placeholder="খতিয়ান নং" className="input-field py-1.5 text-sm" data-id="element-1019" />
              <input type="date" name="publishDate" value={filters.publishDate} onChange={handleFilterChange} className="input-field py-1.5 text-sm" data-id="element-1020" />
            </div>
            <div className="flex justify-end space-x-2" data-id="element-1021">
              <button onClick={resetFilters} className="btn-secondary py-1.5 px-3 text-sm flex items-center" data-id="element-1022">
                <RotateCcw size={14} className="mr-1" data-id="element-1023" /> রিসেট
              </button>
              <button className="btn-primary py-1.5 px-4 text-sm flex items-center" data-id="element-1024">
                <Search size={14} className="mr-1" data-id="element-1025" /> খুঁজুন
              </button>
            </div>
          </div>

          <div className="flex-1 overflow-auto" data-id="element-1026">
            <table className="min-w-full divide-y divide-slate-200" data-id="element-1027">
              <thead className="bg-slate-50 sticky top-0 z-10" data-id="element-1028">
                <tr data-id="element-1029">
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1030">
                    খতিয়ান নং
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1031">
                    মৌজা (জেএল)
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1032">
                    মালিকের নাম
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1033">
                    জমির পরিমাণ
                  </th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-slate-500 uppercase" data-id="element-1034">
                    পদক্ষেপ
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-slate-200" data-id="element-1035">
                {filteredKhatians.map(khatian => <tr key={khatian.id} className={`hover:bg-slate-50 cursor-pointer ${selectedKhatian?.id === khatian.id ? 'bg-teal-50' : ''}`} onClick={() => setSelectedKhatian(khatian)} data-id="element-1036">
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-bold text-slate-900" data-id="element-1037">
                      {khatian.khatianNo}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600" data-id="element-1038">
                      {khatian.mouja} ({khatian.jlNo})
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-900 font-bengali" data-id="element-1039">
                      {khatian.ownerName}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-1040">
                      {khatian.area}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium" data-id="element-1041">
                      <button className="text-teal-600 hover:text-teal-900" data-id="element-1042">
                        <Eye size={18} data-id="element-1043" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Detail Panel */}
        {selectedKhatian && <div className="w-full lg:w-2/3 bg-slate-200 rounded-lg border border-slate-300 shadow-inner flex flex-col overflow-hidden animate-in slide-in-from-right-4" data-id="element-1044">
            <div className="p-3 border-b border-slate-300 bg-slate-800 text-white flex justify-between items-center shadow-sm z-10" data-id="element-1045">
              <h2 className="font-semibold flex items-center text-sm" data-id="element-1046">
                <FileText size={16} className="mr-2 text-teal-400" data-id="element-1047" />
                নথি ভিউ: খতিয়ান {selectedKhatian.khatianNo}
              </h2>
              <div className="flex items-center space-x-3" data-id="element-1048">
                <button className="text-slate-300 hover:text-white flex items-center text-xs bg-slate-700 px-2 py-1 rounded" data-id="element-1049">
                  <Download size={14} className="mr-1" data-id="element-1050" /> পিডিএফ ডাউনলোড করুন
                </button>
                <button onClick={() => setSelectedKhatian(null)} className="text-slate-400 hover:text-white p-1" data-id="element-1051">
                  ✕
                </button>
              </div>
            </div>

            <div className="p-6 flex-1 overflow-y-auto flex justify-center items-start" data-id="element-1052">
              <div className="w-full max-w-4xl shadow-xl" data-id="element-1053">
                <KhatianDocument khatian={selectedKhatian} data-id="element-1054" />
              </div>
            </div>
          </div>}
      </div>
    </div>;
};